import React from 'react';
import './Classes.css';

const Classes: React.FC = () => {
  return (
    <div className="classes-page">
      <h1>Classes and Certifications</h1>
      <div className="current-classes">
        <h2>Certifications</h2>
        <ul>
          <li>AWS Certified Cloud Practitioner</li>
          <li>AWS Partner: Technical Accredited</li>
          <li>Spring Framework Master Class - Java Spring the Modern Way </li>
          <li>DevOps, CI/CD for Beginners </li>
          <li>Introduction to Cloud Computing </li>
        </ul>
      </div>
      <div className="previous-courses">
        <h2>Courses at Northeastern Undergraduate</h2>
        <p>Graduated Magna Cum Laude, May 2025</p>
        <div className="courses-columns">
          <div className="column">
            <h4>Technical</h4>
            <ul>
              <li>Algorithms & Data</li>
              <li> Web Development</li>
              <li>Foundations of Cybersecurity</li>
              <li>Object-Oriented Design</li>
              <li>Fundamentals of Computer Science I & II</li>
              <li>Discrete Structures</li>
              <li>Mathematics of Data Models</li>
              <li>Intro to Math Reasoning</li>
              <li>Directed Study for Computer Science</li>
              <li>Information System Design & Development</li>
              <li>Computer Systems</li>
              <li>Empirical Research Methods</li>
              <li>Fundamentals of Software Engineering</li>
              <li>Human Computer Interaction</li>
              <li>Principles of Information Science</li>
              <li>Theory of Computation</li>
              <li>Introduction to Digital Design</li>
            </ul>
          </div>
          <div className="column">
            <h4>Transferable</h4>
            <ul>
              <li>Cognition</li>
              <li>Dynamic Earth</li>
              <li>History of Technology</li>
              <li>American Sign Language</li>
              <li>Introduction to Contemporary Moral Issues</li>
              <li>Advanced Writing</li>
              <li>Improvisation</li>
              <li>Introduction to Acting</li>

            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Classes;
